import { isSameId } from "../../helpers";
import { tempID } from "@wx/lib-state";
export default function (store, { id, cardId, comment }) {
    if (cardId) {
        const state = store.getState();
        const { currentUser } = state;
        const commentId = id || comment.id || tempID();
        const commentCard = cardId || comment.cardId;
        if (!commentCard || !currentUser) {
            return;
        }
        const cards = state.cards.map(c => {
            if (isSameId(c.id, commentCard)) {
                return {
                    ...c,
                    comments: [
                        ...(c.comments || []),
                        {
                            ...comment,
                            id: commentId,
                            cardId: commentCard,
                            userId: currentUser,
                            date: comment.date || new Date(),
                        },
                    ],
                };
            }
            return c;
        });
        store.setState({ cards });
        return () => {
            store.in.exec("delete-comment", {
                id: commentId,
                cardId: commentCard,
                $meta: { skipHistory: true },
            });
        };
    }
}
//# sourceMappingURL=add.js.map